import * as React from "react";
import { Button } from "components/bootstrap";
import ClipboardContainer from "components/common/ClipboardContainer";
const ClipboardButton = ({
  bsSize = void 0,
  bsStyle = void 0,
  buttonTitle = void 0,
  className = void 0,
  disabled = void 0,
  onSuccess = void 0,
  text,
  title
}) => /* @__PURE__ */ React.createElement(ClipboardContainer, { text }, ({ copy }) => /* @__PURE__ */ React.createElement(
  Button,
  {
    bsSize,
    bsStyle,
    className,
    disabled,
    title: buttonTitle,
    onClick: () => {
      copy();
      onSuccess == null ? void 0 : onSuccess();
    }
  },
  title
));
export default ClipboardButton;
